import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaOrderFormModule } from '@vendasta/store';
import { MatCardModule } from '@angular/material/card';
import { VaIconModule } from '@vendasta/uikit';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { TranslateModule } from '@ngx-translate/core';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from './assets/i18n/en_devel.json';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { ProjectTrackerModule } from '@vendasta/project-tracker';
import { WorkOrderSalesOrderSummaryComponent } from './work-order-sales-order-summary/work-order-sales-order-summary.component';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { WorkOrderLandingPageComponent } from './work-order-landing-page/work-order-landing-page.component';
import { WorkOrdersPageCardComponent } from './work-order-landing-page/card/card.component';
import { WorkOrdersPageDateInfoComponent } from './work-order-landing-page/date-info/date-info.component';
import { WorkOrderPageOrderInfoComponent } from './work-order-landing-page/order-info/order-info.component';
import { FulfillmentOrderPipesModule } from './work-order-landing-page/pipes/fulfillment-order-pipes.module';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { WorkOrderCommunicationDetailsComponent } from './work-order-landing-page/communication-details/communication-details.component';
import { FormConflictDialogComponent } from './work-order-form/form-conflict-dialog/form-conflict-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { FormErrorDialogComponent } from './work-order-form/form-error-dialog/form-error-dialog.component';
import { FormConfirmDialogComponent } from './work-order-form/form-confirm-dialog/form-confirm-dialog.component';
import { WorkOrderActionBannerComponent } from './work-order-landing-page/action-banner/action-banner.component';
import { MatListModule } from '@angular/material/list';
import { FormatUserPipe, SendEmailDialogComponent } from './send-email-dialog/send-email-dialog.component';
import { PendingApprovalsCardComponent } from './work-order-landing-page/pending-approvals/pending-approvals-card/pending-approvals-card.component';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UsersModule } from '@vendasta/users';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'common/work-order',
      baseTranslation: baseTranslation,
    }),
    MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    OverlayModule,
    VaIconModule,
    VaOrderFormModule,
    GalaxySnackbarModule,
    ProjectTrackerModule,
    GalaxyAvatarModule,
    GalaxyBadgeModule,
    MatProgressBarModule,
    FulfillmentOrderPipesModule,
    RouterModule,
    MatExpansionModule,
    ProjectTrackerModule,
    MatDialogModule,
    GalaxyAlertModule,
    MatListModule,
    PendingApprovalsCardComponent,
    GalaxyFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    FormatUserPipe,
    UsersModule,
    StatusBadgeComponent,
  ],
  declarations: [
    WorkOrderSalesOrderSummaryComponent,
    SendEmailDialogComponent,
    WorkOrderLandingPageComponent,
    WorkOrdersPageCardComponent,
    WorkOrdersPageDateInfoComponent,
    WorkOrderPageOrderInfoComponent,
    WorkOrderCommunicationDetailsComponent,
    WorkOrderActionBannerComponent,
    FormConflictDialogComponent,
    FormErrorDialogComponent,
    FormConfirmDialogComponent,
  ],
  exports: [
    WorkOrderSalesOrderSummaryComponent,
    WorkOrderLandingPageComponent,
    SendEmailDialogComponent,
    WorkOrderCommunicationDetailsComponent,
    FormConflictDialogComponent,
    WorkOrderActionBannerComponent,
  ],
})
export class WorkOrderModule {}
